import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=787c1e22&scoped=true&"
import script from "./reviewList.vue?vue&type=script&lang=ts&"
export * from "./reviewList.vue?vue&type=script&lang=ts&"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=787c1e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c1e22",
  null
  
)

export default component.exports